// import { useState } from "react";

// // Import Worker
// import { Worker } from "@react-pdf-viewer/core";
// // Import the main Viewer component
// import { Viewer } from "@react-pdf-viewer/core";
// // Import the styles
// import "@react-pdf-viewer/core/lib/styles/index.css";
// // default layout plugin
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// // Import styles of default layout plugin
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

// // Zoom
// import { zoomPlugin } from "@react-pdf-viewer/zoom";
// import "@react-pdf-viewer/zoom/lib/styles/index.css";
// // CurrentScale, ZoomInIcon, ZoomOutIcon
// function App() {
//   // creating new plugin instance
//   const defaultLayoutPluginInstance = defaultLayoutPlugin();

//   // zoom

//   const zoomPluginInstance = zoomPlugin();
//   const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

//   // pdf file onChange state
//   const [pdfFile, setPdfFile] = useState(null);

//   // pdf file error state
//   const [pdfError, setPdfError] = useState("");

//   const pageNavigationPluginInstance = pageNavigationPlugin();
//   const {
//     GoToFirstPage,
//     GoToLastPage,
//     GoToNextPage,
//     GoToPreviousPage,
//     CurrentPageLabel
//   } = pageNavigationPluginInstance;

//   // handle file onChange event
//   const allowedFiles = ["application/pdf"];
//   const handleFile = (e) => {
//     let selectedFile = e.target.files[0];
//     // console.log(selectedFile.type);
//     if (selectedFile) {
//       if (selectedFile && allowedFiles.includes(selectedFile.type)) {
//         let reader = new FileReader();
//         reader.readAsDataURL(selectedFile);
//         reader.onloadend = (e) => {
//           setPdfError("");
//           setPdfFile(e.target.result);
//         };
//       } else {
//         setPdfError("Not a valid pdf: Please select only PDF");
//         setPdfFile("");
//       }
//     } else {
//       console.log("please select a PDF");
//     }
//   };

//   return (
//     <div className="container">
//       {/* Upload PDF */}
//       <form>
//         <label>
//           <h5>Upload PDF</h5>
//         </label>
//         <br></br>

//         <input
//           type="file"
//           className="form-control"
//           onChange={handleFile}
//         ></input>

//         {/* we will display error message in case user select some file
//         other than pdf */}
//         {pdfError && <span className="text-danger">{pdfError}</span>}
//       </form>

//       {/* View PDF */}
//       <h5>View PDF</h5>

//       <div className="viewer">
//         {/* render this if we have a pdf file */}
//         {pdfFile && (
//           <>
//             <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
//               <Viewer
//                 fileUrl={pdfFile}
//                 plugins={[pageNavigationPluginInstance, zoomPluginInstance]}
//                 defaultScale={1}
//                 // plugins={[defaultLayoutPluginInstance]}
//               ></Viewer>
//             </Worker>
//             <div className="container-fluid">
//               <div className="row">
//                 <div
//                   className="col d-flex justify-content-center align-items-center"
//                   style={{ height: "50px" }}
//                 >
//                   {/* Insert your button(s) here */}
//                 </div>
//               </div>
//             </div>
//           </>
//         )}

//         {/* render this if we have pdfFile state null   */}
//         {!pdfFile && <>No file is selected yet</>}
//       </div>
//     </div>
//   );
// }

// export default App;
import { useState, useRef } from "react";

// Import Worker
import { Worker } from "@react-pdf-viewer/core";
// Import the main Viewer component
import { Viewer } from "@react-pdf-viewer/core";
// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
// default layout plugin
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// Import styles of default layout plugin
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

// Zoom
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

import { pdfTextExtract } from "./brains/pdf/pdfExtract";
// import Chats from "./chats/chatbox";
// import ChatModal2 from "./chats/ChatModal2";

function App({ getHighlightedText, getIsHighlightedText, getText }) {
  // creating new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const divRef = useRef(null);

  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

  // pdf file onChange state
  const [pdfFile, setPdfFile] = useState(null);

  // pdf file error state
  const [pdfError, setPdfError] = useState("");

  const [text, setText] = useState("");

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel
  } = pageNavigationPluginInstance;
  const [highlightedText, setHighlightedText] = useState("");
  // get highlighted

  const handleMouseUp = () => {
    console.log("i got text! highlights")
    const selection = window.getSelection();
    const selectedText = selection.toString();
    setHighlightedText(selectedText);
    getHighlightedText(selectedText);
    getIsHighlightedText(true); // this will activate Modal
    console.log(selectedText);
  };
  // handle file onChange event
  const allowedFiles = ["application/pdf"];
  const handleFile = async (e) => {
    let selectedFile = e.target.files[0];
    // console.log(selectedFile.type);
    if (selectedFile) {
      if (selectedFile && allowedFiles.includes(selectedFile.type)) {
        const pdfText = await pdfTextExtract(selectedFile);
        // setText(await pdfTextExtract(selectedFile));
        setText(pdfText);
        getText(pdfText);
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onloadend = (e) => {
          setPdfError("");
          setPdfFile(e.target.result);
        };
      } else {
        setPdfError("Not a valid pdf: Please select only PDF");
        setPdfFile("");
      }
    } else {
      console.log("please select a PDF");
    }
  };

  // console.log("i am text from pdf in pdfInput", text);
  return (
    <div className="container">
      {/* Upload PDF */}
      <form>
        <label>
          <h5>Upload PDF</h5>
        </label>
        <br></br>

        <input
          type="file"
          className="form-control"
          onChange={handleFile}
        ></input>

        {/* we will display error message in case user select some file
        other than pdf */}
        {pdfError && <span className="text-danger">{pdfError}</span>}
      </form>

      {/* View PDF */}
      <h5>View PDF</h5>

      <div
        className="viewer"
        ref={divRef}
        onMouseUp={handleMouseUp}
        style={{ userSelect: "text" }}
      >
        {/* render this if we have a pdf file */}
        {pdfFile && (
          <>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <Viewer
                fileUrl={pdfFile}
                plugins={[pageNavigationPluginInstance, zoomPluginInstance]}
                defaultScale={1}
              ></Viewer>
            </Worker>
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col d-flex justify-content-center align-items-center"
                  style={{ height: "50px" }}
                >
                  {/* Insert your button(s) here */}
                </div>
              </div>
            </div>
          </>
        )}

        {/* render this if we have pdfFile state null   */}
        {!pdfFile && <>No file is selected yet</>}
      </div>
      {/* <ChatModal2 /> */}
    </div>
  );
}

export default App;
